import { useMutation, useQuery } from 'data-fetching-client';
import { SUBMIT_CTA_RECOMMENDATION_MODEL_V2_CLICK } from 'pricing-pages-api/recommendation-model/mutations';
import { GET_RECOMMENDED_API_V2 } from 'pricing-pages-api/recommendation-model/queries';
import Raven from 'raven-js';
import { PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { MARKETING, SALES } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../constants/routing/NavItems';
import { useAppSelector } from '../reducers';
import { currentSuiteApiNamesForProductLevelSelector, productSelector } from '../selectors/ProductsSelectors';
import { useGlobalLoading } from './loadingHooks';
import { useShowProductV2ModelRecommendedBadge } from './useShowProductV2ModelRecommendedBadge';
export const useRecommendedProduct = () => {
  const queryResult = useQuery(GET_RECOMMENDED_API_V2);
  const {
    data,
    loading
  } = queryResult;
  const recommendationResponse = data === null || data === void 0 ? void 0 : data.recommendedApiV2;
  return {
    recommendationResponse,
    loading
  };
};
export const useIsRecommendedStarterCustomerPlatform = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === 'CRM_SUITE' && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === STARTER;
};
export const useIsRecommendedSalesHubPro = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === SALES && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === PROFESSIONAL;
};
export const useGetRecommendedApiNames = () => {
  const isAppReady = useGlobalLoading();
  const {
    recommendationResponse,
    loading
  } = useRecommendedProduct();
  const hub = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub;
  const tier = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier;
  return useAppSelector(state => {
    if (!isAppReady || loading) {
      return {
        apiNames: undefined,
        loading: true
      };
    }
    if (hub === 'CRM_SUITE') {
      const suiteApiNames = tier && currentSuiteApiNamesForProductLevelSelector(state, {
        productLevel: tier
      });
      return {
        apiNames: suiteApiNames,
        loading: false
      };
    } else if (hub && tier) {
      const product = productSelector(state, {
        productLevel: tier,
        productLine: hub
      });
      const apiName = product && product.apiName;
      const apiNames = apiName ? [apiName] : undefined;
      return {
        apiNames,
        loading: false
      };
    }
    return {
      apiNames: undefined,
      loading: false
    };
  });
};
export const useRecommendedRouting = () => {
  const {
    recommendationResponse,
    loading
  } = useRecommendedProduct();
  const recommendedProductLine = (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) || MARKETING;
  const recommendedRoute = recommendedProductLine === 'CRM_SUITE' ? NavItemEnum.SUITE : recommendedProductLine.toLowerCase();
  return {
    recommendedRoute,
    loading
  };
};
export const useSuiteRecommendationModelFeedback = ({
  productLevel
}) => {
  const showProductV2ModelRecommendedBadge = useShowProductV2ModelRecommendedBadge({
    productLevel,
    productLine: 'CRM_SUITE'
  });
  const {
    recommendationResponse
  } = useRecommendedProduct();
  const recommendedCorrelationId = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.correlationId;
  const [submitTrackRecommendationModelFeedback, {
    loading
  }] = useMutation(SUBMIT_CTA_RECOMMENDATION_MODEL_V2_CLICK);
  const onClick = () => {
    if (!loading && recommendedCorrelationId && showProductV2ModelRecommendedBadge) {
      submitTrackRecommendationModelFeedback({
        variables: {
          correlationId: recommendedCorrelationId
        }
      }).catch(error => {
        Raven.captureException(error, {
          fingerprint: ['Failed to submit CTA click of V2 recommended hub and tier in Suite Card']
        });
      });
    }
  };
  return {
    onClick
  };
};